import { MessageService } from 'primeng/api';
import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteService } from '../../service/quote.service';
import { SharedComponentsModule } from '../../../shared/shared-components/shared-components.module';
import {NmbService} from "../../service/nmb.service";

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrl: './payment-success.component.scss',
    providers: [MessageService],
})
export class PaymentSuccessComponent implements OnInit {
    private quoteId: number;
    checkoutId!: string;
    visible!: boolean;
    screenWidth: number = 1200;

    message: string ='';
    status: string='';
    providerRef: string ='';
    loading: boolean = false;
    showResultDialog: boolean = false;

    constructor(
        private router: Router,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private nmb: NmbService,
        private renderer: Renderer2,
        private quoteService: QuoteService
    ) {}

    ngOnInit(): void {
        this.extractQueryParams()
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.onResize.bind(this));
    }

    extractQueryParams(){
        this.route.queryParams.subscribe(params => {
            this.checkoutId = params['id'];
        });
        this.fetchStatus();
    }

    onResize(event: Event) {
        this.screenWidth = window.innerWidth;
    }

    fetchStatus(){
        this.loading = true;
        this.nmb.getStatus(this.checkoutId).subscribe({
            next: data => {
                this.loading = false;
                this.message=data.message;
                this.status=data.status;
                this.providerRef = data.providerReference;

                this.showResultDialog = true;
            },
            error: err => {
                this.loading=false;
                console.log(err)
            }
        })
    }


    replaceUnderscores(value: string): string {
      return value.replace(/_/g, ' ');
    }

    showSuccessMessage(message: string) {
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: message,
            life: 2500,
        });
    }

    showErrorMessage(message: string) {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: message,
            life: 2500,
        });
    }

    showDialog(): void {
        this.visible = true;
    }

    closeDialog(): void {
        this.visible = false;
    }
}
